import React from "react";

export default function PreviewTable({ data, config }) {
  const maxPreviewRows = 10;

  return (
    <div className="preview-table mt-3 mb-3">
      <h6>데이터 미리보기 ({data.length}개 행)</h6>
      <div
        className="table-responsive"
        style={{
          maxHeight: "400px",
          overflowX: "auto",
          overflowY: "auto",
        }}
      >
        <table
          className="table table-sm table-bordered"
          style={{ minWidth: "1200px" }}
        >
          <thead className="table-light sticky-top">
            <tr>
              <th width="50">행</th>
              <th width="70">액션</th>
              {config.columns.map((col) => (
                <th key={col.field} width={col.width || 120}>
                  {col.headerName}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.slice(0, maxPreviewRows).map((row, index) => (
              <tr key={index}>
                <td className="text-center">{row._rowNumber}</td>
                <td className="text-center">
                  <span
                    className={`badge ${
                      row._action === "create" ? "bg-success" : "bg-warning"
                    }`}
                  >
                    {row._action === "create" ? "신규" : "수정"}
                  </span>
                </td>
                {config.columns.map((col) => {
                  const value = row[col.table][col.field];

                  // update 액션이면서 해당 필드가 스킵된 경우 특별 표시
                  if (
                    row._action === "update" &&
                    row._skippedFields &&
                    row._skippedFields.includes(col.field)
                  ) {
                    return (
                      <td
                        key={col.field}
                        className="text-truncate text-muted fst-italic"
                        style={{ maxWidth: "150px", minWidth: "100px" }}
                      >
                        기존 값 유지
                      </td>
                    );
                  }

                  return (
                    <td
                      key={col.field}
                      className="text-truncate"
                      style={{ maxWidth: "150px", minWidth: "100px" }}
                    >
                      {value || ""}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
        {data.length > maxPreviewRows && (
          <p className="text-center text-muted">
            ... 외 {data.length - maxPreviewRows}개 행
          </p>
        )}
      </div>
    </div>
  );
}
